export default function CollegeStationServicesSection() {
  const services = [
    {
      icon: "ri-alarm-warning-line",
      title: "Emergency Passport",
      badge: "Same-Day Available",
      badgeColor: "bg-red-100 text-red-700",
      bullets: [
        "Last-minute study abroad departure",
        "24–48 hour processing for A&amp;M students and faculty",
        "Same-day document review and submission",
      ],
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      badge: "Most Common",
      badgeColor: "bg-green-100 text-green-700",
      bullets: [
        "Expired or near-expiring passport renewal",
        "No office visit required for most renewals",
        "Faster than USPS standard processing",
      ],
    },
    {
      icon: "ri-passport-line",
      title: "New Passport",
      badge: null,
      badgeColor: "",
      bullets: [
        "First-time applications for A&amp;M students",
        "International graduate student support",
        "Full DS-11 form guidance and facility assistance",
      ],
    },
    {
      icon: "ri-error-warning-line",
      title: "Lost or Stolen Passport",
      badge: "Urgent",
      badgeColor: "bg-orange-100 text-orange-700",
      bullets: [
        "DS-64 form guidance for Brazos Valley residents",
        "Emergency replacement processing",
        "Priority handling for imminent academic travel",
      ],
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      badge: null,
      badgeColor: "",
      bullets: [
        "Minors under 16 with parental consent guidance",
        "Both parents or DS-3053 notarized consent",
        "Brazos Valley family travel support",
      ],
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      badge: null,
      badgeColor: "",
      bullets: [
        "Passport correction after marriage or divorce",
        "Legal name change documentation assistance",
        "Texas court order and supporting document review",
      ],
    },
    {
      icon: "ri-stack-line",
      title: "Second Passport",
      badge: null,
      badgeColor: "",
      bullets: [
        "For faculty with overlapping research travel",
        "Primary held for visa while second is in use",
        "Ideal for frequent academic conference travelers",
      ],
    },
    {
      icon: "ri-global-line",
      title: "International Student Support",
      badge: null,
      badgeColor: "",
      bullets: [
        "Passport renewal for international Aggies",
        "Consulate document coordination guidance",
        "F-1/J-1 visa document timing assistance",
      ],
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      badge: null,
      badgeColor: "",
      bullets: [
        "Wallet-size card for land & sea crossings",
        "Valid for Mexico, Canada & Caribbean border entry",
        "Lower cost option for student spring break travel",
      ],
    },
  ];

  return (
    <section id="services" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Our Services</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">College Station Passport Services</h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Complete passport solutions for Aggieland — Texas A&amp;M students and faculty, Brazos Valley families, and international scholars in the Bryan-College Station metro.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {services.map((s, i) => (
            <div key={i} className="bg-white rounded-lg p-6 border border-gray-200 hover:border-[#F6C344] transition-all flex flex-col">
              <div className="flex items-start justify-between mb-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#1A365D]/5 flex-shrink-0">
                  <i className={`${s.icon} text-[#1A365D] text-lg`}></i>
                </div>
                {s.badge && (
                  <span className={`text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap ${s.badgeColor}`}>
                    {s.badge}
                  </span>
                )}
              </div>
              <h3 className="font-bold text-[#1A365D] text-sm mb-3">{s.title}</h3>
              <ul className="space-y-1.5 flex-1 mb-4">
                {s.bullets.map((b, j) => (
                  <li key={j} className="flex items-start gap-2">
                    <i className="ri-check-line text-[#F6C344] text-xs flex-shrink-0 mt-0.5"></i>
                    <span className="text-gray-500 text-xs leading-relaxed">{b}</span>
                  </li>
                ))}
              </ul>
              <a
                href="https://fastpassportcenter.com/checkout/"
                className="inline-flex items-center gap-1 text-[#1A365D] hover:text-[#F6C344] text-xs font-semibold transition-colors"
              >
                Get Started <i className="ri-arrow-right-line text-xs"></i>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}